export default __webpack_public_path__ + "static/Plots0051-f68bb2c165b0bcbae5d155cf59300f54.jpg";